import * as React from "react";
import { forwardRef } from "react";
const SvgGreenPlant = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 102, height: 102, viewBox: "0 0 102 102", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M51 51C51 22.7821 28.1379 0 0 0V51C0 79.1379 22.7821 102 51 102C79.1379 102 102 79.2179 102 51V0C73.7821 0 51 22.7821 51 51Z", fill: "#20A76A" }));
const ForwardRef = forwardRef(SvgGreenPlant);
export { ForwardRef as ReactComponent };
